@let disabled = disabled$ | async;
<app-control-wrapper
  [control]="control"
  [officeField]="officeField"
  [formGroupInstance]="formGroupInstance"
  [errorsMessagesOverridesRegistry]="errorsMessagesOverridesRegistry"
  [required]="control | controlHasRequired"
  [validating]="validating$()"
  [alignment]="alignment"
  [disabled]="disabled"
  [touched]="isTouched$ | async"
  [dirty]="isDirty$ | async"
  [config]="config">
  <ng-container [ngSwitch]="type">
    <ng-container *ngSwitchCase="InputTypeEnum.percent">
      <app-input-percent
        #inputRef
        [class]="'form-control'"
        [placeholder]="officeField?.InputMask || ''"
        [formControl]="control"
        [name]="officeField.VistaFormItem.ColumnName"
        [controlName]="officeField.Seq"
        [maxlength]="inputMaskConfig?.inputLength || officeField.InputLength"
        [inputMaskConfig]="inputMaskConfig"
        [inputTransformFn]="inputTransformFn"></app-input-percent>
    </ng-container>
    <ng-container *ngSwitchCase="InputTypeEnum.textarea">
      <textarea
        #inputRef
        class="form-control"
        [name]="officeField.VistaFormItem.ColumnName"
        [formControl]="control"
        [maxlength]="officeField.InputLength"></textarea>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <app-input-custom
        #inputRef
        [class]="'form-control'"
        [placeholder]="officeField?.InputMask || ''"
        [formControl]="control"
        [name]="officeField.VistaFormItem.ColumnName"
        [controlName]="officeField.Seq"
        [maxlength]="inputMaskConfig?.inputLength || officeField.InputLength"
        [type]="type"
        [officeField]="officeField"
        [inputMaskConfig]="inputMaskConfig"
        [inputTransformFn]="inputTransformFn"></app-input-custom>
    </ng-container>
  </ng-container>
</app-control-wrapper>
